var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-wrapper"},[_c('LandingHeader'),_vm._v(" "),_c('nuxt',{staticClass:"landing-main"}),_vm._v(" "),_c('LandingFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }